/**
 * v-class-state
 *
 * <a v-class-state:click.className="key"> toggle</a>
 */
export default {
  bind(el, binding, vnode) {
    const vm = vnode.context
    const action = binding.arg || 'click'
    const classNames = Object.keys(binding.modifiers)
    const key = `${vm.$options.name}:${binding.value}`

    let state = vm.$storage.getState(key)
    if (state) {
      el.classList.toggle.apply(el.classList, classNames)
    }

    el.addEventListener(action, function() {
      state = !state
      vm.$storage.setState(key, state)
      el.classList.toggle.apply(el.classList, classNames)
    })
  }
}
